<template>
  <div class="accredit">
    <div class="title">企业信息采集及使用授权委托书</div>
    <div class="message">
      <div class="item">企业名称：{{ name }}</div>
      <div class="item">统一社会信用代码：{{ cNo }}</div>
      <div class="item">法定代表人姓名：{{ personnel }}</div>
      <div class="item">联系电话：{{ phone }}</div>
      <div class="item">授权书签订日期：{{ time | formatDate }}</div>
    </div>
    <div class="content">
      <!-- 尊敬的用户为组护授权企业合法权益，请在签署本授权委托书前，仔细阅计、东分理解各条款、特别品免减轻被授权人责任，或限制授权企业权利的条款。<br />
      一、授权企业在此同意并授权安康市中小企业动资服务平台(实际运营方:安康市大数据运营有限公司(下称“安康大数据”)对授权企业相关信息予以采集和查询。所涉企业相关信息包括但不限于如下信息企业集本信息、企业生产经营信息、企业市场发展信息、企业资产信息、企业财务信息、企业及务信息、企业公共信用信息、企业动资信息、企司法信息、人民银行企业征信报告和企业法人及(高管、董事、监事)个人征信报告、其它企业信息等。
      <br />
      二、授权企业在此同愈并确认上述“采集和查询”包括从国家机关、政府门、事业单位、金融机构等相关部门和单位采生上深信别包括历史信息及更领]。也包括以行业协会、社会团体、互联网信息平台渠道等取得上述信息。本企业在此没权上述有关部门和单位向安康市中小企业动资服务平台、运营方安康金融局、入驻平台提供动资服务的金融机构提供本企业上述信息。
      <br />
      三、授权企业在此同意并授权安康市中小企业融资服务平台查询并使用本企业的上述信息。
      <br />
      四、授权企业在此承诺国家机关、政府部门、事业单位等部门和单位,因行政管理、公共服务的乐要可以直接查询企业的上述信息。运营方安康大数据根据要求可以向上述部门和单位提供上述信息。
      <br />
      五、本委托书所涉全部授权自本授权书委托书签订之日起生效，授权期限为长期。
      <br />
      六、如需终止本委托书授权的查询授权，无要项写《企业征信系练信息查询授权终止书》并提供相关资,运方检林金融局核、满足终止授权条件的可以终止、如更终止本委托书授权的采集授权，需携带《企业征信系统信息采集授权终止书》查询授权终止的回执及相关企业材料到运营方检林金融局现场办理。
      <br />
      七、授权企业在此产明并确认其已知恶并理解本授权委托书的全部内容，并自医承担因提供非公开信息及负面信息可能导致的任何不利后果。 -->
    </div>
  </div>
</template>
<script>
import { getEnterprise } from "./viewApi";
import { formatDate } from "@/filters/index";

export default {
  data() {
    return {
      name: "",
      cNo: "",
      personnel: "",
      phone: "",
      time: "2022-02-22 14:11:41", };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let res = await getEnterprise();
      this.name = res.data.qymc;
      this.cNo = res.data.dm;
      this.personnel = res.data.fddbr;
      this.phone = res.data.qylxdh;
      this.time = res.data.enterTime;
    },
  },
};
</script>
<style lang="scss" scoped>
.accredit {
  height: 100%;
 background: white;
 border-radius: 16px;
 padding: 10px;
  .title {
    border-bottom: 1px solid #ccc;
    line-height: 40px;
    padding: 0 10px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: left;
  }
  .message {
    border: 1px solid #ccc;
    padding: 20px;
    margin-bottom: 20px;
    .item {
      display: inline-block;
      width: 45%;
      line-height: 40px;
    }
  }
  .content {
    text-indent: 2rem;
    line-height: 30px;
  }
}
</style>
